import * as PIXI from 'pixi.js';
import { WIDTH, HEIGHT } from '../constants';
import { popIn, moveToRainbow, slideDown, screenSplash, crazy} from '@/util/tween';
import { createText, createMenuItem } from '@/ui/menu-builder';
import { EVENT_BUS } from '@/model/event-bus';
import { ENGINE_X, ENGINE_Y } from '@/scenes/game-scene';
import { SCROLL_WINDOW_PX } from '@/components/engine';
import { PixiPiano } from '@/components/piano-component';
import game from '@/model/game';
import { animateMaterialColor, shake } from '@/util/tween'
import { animateNoteOn, animateNoteMiss, LINE_MATERIAL_1, LINE_MATERIAL_2 } from '@/components/three/highway';
import { RAY_MATERIAL } from '@/components/three/piano-3d';
export const GUI_X = WIDTH * 0.91, GUI_Y = 200, PROGRESS_BAR_BORDER = 4, PIANO_HEIGHT = 120;
const PROGRESS_BAR_EMPTY = 0x333333, PROGRESS_BAR_FILL = 0x89c95e, PROGRESS_BAR_FILL2 = 0xFF0000;
const splashFontStyle = new PIXI.TextStyle({
    fontFamily: 'Arial',
    fontSize: 27,
    fontStyle: 'italic',
    fontWeight: 'bold',
    fill: ['#ffffff', '#FFD700'], // gradient
    stroke: '#4a1850',
    strokeThickness: 5,
    dropShadow: true,
    dropShadowColor: '#000000',
    dropShadowBlur: 4,
    dropShadowAngle: Math.PI / 6,
    dropShadowDistance: 6,
    wordWrap: true,
    wordWrapWidth: 440,
    lineJoin: 'round',
    align: 'center'
});

function createProgressBar() {
    const graphics = new PIXI.Graphics();
    graphics.x = GUI_X - 550;
    graphics.y = GUI_Y;
    graphics.width = 400;
    graphics.height = 40;
    graphics.beginFill(PROGRESS_BAR_EMPTY);
    graphics.drawRect(0, 0, 400, 40);
    graphics.endFill();
    return graphics;
}

export class Gui extends PIXI.Container {
    constructor({
        pianoWidth = 600,
        pianoKeyWidth = 26,
        pianoKeyBorder = 1,
        pianoHighlightHeight = PIANO_HEIGHT,
        boundaries
    } = {}) {
        super();
        console.log('gui boundaries', boundaries);
        this.boundaries = boundaries;
        this.pianoWidth = pianoWidth;
        this.pianoKeyWidth = pianoKeyWidth;
        this.pianoKeyBorder = pianoKeyBorder;
        this.pianoHighlightHeight = pianoHighlightHeight;
        this.addScorePanel();
        this.addProgressBar();
        this.addComboMeter();
    }

    addScorePanel() {
        this.scorePanel = createMenuItem({
            variation: '05',
            suppressMouseEvents: true,
            text: `${game.totalNotesHit} / ${game.totalNotesHit + game.totalNotesMissed}`,
            yCoord: GUI_Y,
            xCoord: GUI_X,
            width: 300,
            height: 80
        });
        this.addChild(this.scorePanel);
    }

    addProgressBar() {
        this.progressBarGraphics = createProgressBar();
        const progressBarValue = createText({ text: '' });
        progressBarValue.position.set(GUI_X - 360, GUI_Y + 20)
        progressBarValue.anchor.set(0.5, 0.5)
        this.progressBarValue = progressBarValue;
        this.addChild(this.progressBarGraphics);
        this.addChild(this.progressBarValue);
    }

    createPiano() {
        const pianoConfig = this.boundaries;
        if (this.piano) {
            this.removeChild(this.piano);
            this.removeChild(this.pianoLabel);
        }
        const label = createText({
            text: pianoConfig.title,
            fill: ['0x333333'],
            fontSize: 18
        })
        label.position.set(WIDTH * 0.25 + label.width / 2, HEIGHT - 166)
        const wrapper = new PIXI.Sprite(PIXI.Texture.WHITE);
        wrapper.height = 180;
        wrapper.alpha = 0.5;

        const piano = new PixiPiano({
            WHITE_KEY_COLOR: game.settings.whiteGemColor,
            BLACK_KEY_COLOR: game.settings.blackGemColor,
            boundaries: this.boundaries,
            PIANO_WIDTH: this.pianoWidth,
            PIANO_HEIGHT: PIANO_HEIGHT,
            PIANO_HIGHLIGHT_HEIGHT: this.pianoHighlightHeight,
            BORDER: this.pianoKeyBorder,
            ...pianoConfig
        });
        wrapper.width = WIDTH;
        wrapper.position.y = HEIGHT - 190;
        EVENT_BUS.on('MIDI_noteOn', ({ pianoNote }) => {
            piano.highlightNote(pianoNote);
        });
        EVENT_BUS.on('MIDI_noteOff', ({ pianoNote }) => {
            piano.highlightNote(pianoNote, false);
        });
        this.addChild(wrapper);
        wrapper.addChild(piano);
        piano.position.set(WIDTH / 2, HEIGHT - 150);
        this.addChild(piano);
        this.addChild(label);
        this.piano = piano;
        this.pianoLabel = label;
        return piano;
    }

    initMascots() {
        let cow = this.createMascot({ idx: 1 })
        this.addChild(cow);
        EVENT_BUS.on('GAME_BEAT', () => {
            //this.children.forEach( c => popIn(c, 300) );
        });
        // this.addChild(this.createMascot({idx: 2, variation: 'frog'}));
        // this.addChild(this.createMascot({idx: 3, variation: "hippo"}));
    }

    animateNoteHitAndMiss(note, hit) {
        if (!note || !note.label) {
            console.error('no note to animate');
            return;
        }
        note.label.style = {
            ...note.label.style,
            fill: [hit ? '0x00FF00' : '0xFF0000']
        };

        const clone = note.label.clone();
        clone.style = {
            ...clone.style,
            fill: ['0xFFC0CB']
        };
        clone.x = ENGINE_X + SCROLL_WINDOW_PX + 120;
        clone.y += hit ? ENGINE_Y - 100 : ENGINE_Y + 100;
        if (hit) {
            this.splash(note.xmlNote.grade);
            moveToRainbow(clone, GUI_X, GUI_Y - 100).then(() => {
                this.removeChild(clone);
                popIn(this.scorePanel)
            });
        } else {
            slideDown(clone).then(() => {
                this.removeChild(clone);
                popIn(this.scorePanel)
            });
        }

        this.addChild(clone);
    }

    createMascot({
        variation = 'cow',
        idx = 1
    } = {}) {
        const sprite = PIXI.Sprite.from(`public/images/${variation}.png`);
        if (!this.mascots) {
            this.mascots = [];
        }
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(14 + idx * 140, 120);
        this.mascots.push(sprite);
        return sprite;
    }

    setProgress(percent) {
        if (percent < 0) {
            return;
        }
        this.progressBarGraphics.clear();
        this.progressBarGraphics.beginFill(PROGRESS_BAR_EMPTY);
        this.progressBarGraphics.drawRect(0, 0, 400, 40);
        this.progressBarGraphics.endFill();
        this.progressBarGraphics.beginFill(percent > 0.5 ? PROGRESS_BAR_FILL : PROGRESS_BAR_FILL2);
        this.progressBarGraphics.drawRect(
            PROGRESS_BAR_BORDER,
            PROGRESS_BAR_BORDER,
            (400 - PROGRESS_BAR_BORDER) * percent,
            40 - PROGRESS_BAR_BORDER
        );
        this.progressBarGraphics.endFill();
        this.progressBarValue.text = Math.round(percent * 100) + '%';
    }

    addComboMeter() {
        this.comboMeter = new PIXI.Text('300', {
            ...splashFontStyle,
            fontSize: 200,
            fill: ['#ffffff', '#00FF00'], // gradient
        });
        this.comboMeter.position.set(WIDTH * 0.75, HEIGHT * 0.085);
        this.addChild(this.comboMeter);

        this.comboText = new PIXI.Text('Combo', {
            ...splashFontStyle,
            fontSize: 30,
            fill: ['#ffffff', '#00FF00'], // gradient
        });
        this.comboText.position.set(WIDTH * 0.75, HEIGHT * 0.065);
        this.addChild(this.comboText);
        // EVENT_BUS.on('GAME_BEAT', () => {
            // shake(this, 6, 300);
        // })
    }
    // countdown() {
    //     const times = Game.beats;
    //     const intervalMs = Game.beatIntervalSeconds * 1000;
    //     const screenSplashCountdown = (lblText) => {
    //         const label = new PIXI.Text(`${lblText}`, {
    //             ...style, fontSize: 70
    //         });
    //         label.position.set(WIDTH / 2, HEIGHT / 2);
    //         label.anchor.set(0.5, 0.5);
    //         this.addChild(label);
    //         countdownTween(label, intervalMs * 0.7).then(() => {
    //             this.removeChild(label);
    //         });
    //     }
    //     return new Promise(res => {
    //         for (let i = 0; i < times; i++) {
    //             setTimeout(() => {
    //                 Fx.click();
    //                 screenSplashCountdown(times - i, this.ui);
    //             }, i * intervalMs);
    //         }
    //         setTimeout(() => {
    //             res();
    //         }, intervalMs * times);
    //     })
    // }

    update() {
        this.scorePanel.children[1].text = `${game.totalNotesHit} / ${game.totalNotesHit + game.totalNotesMissed}`
        this.comboMeter.visible = game.comboStreak > 0;
        this.comboText.visible = game.comboStreak > 0;
        if (game.comboStreak != this.comboMeter.text) {
            this.comboMeter.text = game.comboStreak;
            popIn(this.comboMeter);
        }
    }

    splash(text) {
        const splashElement = new PIXI.Text(text, splashFontStyle);
        splashElement.x = WIDTH / 2 - splashElement.width / 2;
        splashElement.y = HEIGHT / 2 - splashElement.height / 2;
        this.addChild(splashElement);
        screenSplash(splashElement).then(()=>{
            this.removeChild(splashElement);
        })
    }

    onReveal() {
        this.createPiano();
    }
}

export class Gui2D extends Gui {
    constructor(config) {
        super(config);
    }

    animateNoteHitAndMiss(note, hit) {
        if (!note || !note.label) {
            console.error('no note to animate');
        }
        note.label.tint = hit ? 0x00FF00 : 0xFF0000;
        
        const clone = new PIXI.Sprite( note.label.texture );
        clone.tint = note.label.tint;
        clone.x = note.label.x + ENGINE_X + WIDTH / 4;
        clone.y = hit ? (HEIGHT - HEIGHT * 0.2 - PIANO_HEIGHT) : ENGINE_Y + 100;
        if (hit) {
            this.piano.setHighlightColor(0x00FF00);
            this.splash(note.xmlNote.grade);
            crazy(clone);
            moveToRainbow(clone, GUI_X, GUI_Y - 100).then(() => {
                this.removeChild(clone);
                popIn(this.scorePanel)
            });
        } else {
            this.piano.setHighlightColor(0xFF0000);
            slideDown(clone).then(() => {
                this.removeChild(clone);
                popIn(this.scorePanel)
            });
        }

        this.addChild(clone);
    }
}

export class Gui3D extends Gui {

    constructor(config) {
        super(config);
        this.scorePanel.position.set(WIDTH - 160, HEIGHT - 40);
        this.progressBarGraphics.position.set(WIDTH - 750, HEIGHT - 60)
        this.progressBarValue.position.set(WIDTH - 550, HEIGHT - 36)
    }

    createPiano() {
        return new PIXI.Container();
    }

    animateNoteHitAndMiss(note, hit) {
        if (!note || !note.gem) {
            console.error('no note to animate');
            return;
        }
        if (hit) {
            note.gem.flame.visible = true;
            animateNoteOn(note.gem, 600).then(
                () => {
                    note.gem.flame.visible = true;
                    note.gem.removeFromParent()
                }
            );
            this.splash(note.xmlNote.grade);
            animateMaterialColor(LINE_MATERIAL_1);
            animateMaterialColor(LINE_MATERIAL_2);
            animateMaterialColor(RAY_MATERIAL, 0xa3f7b5, 0xFFD700, 100);
        } else {
            animateNoteMiss(note.gem);
            animateMaterialColor(RAY_MATERIAL, 0xa3f7b5, 0xFF0000, 100);
            animateMaterialColor(LINE_MATERIAL_1, 0xFFFFFF, 0xFF0000);
            animateMaterialColor(LINE_MATERIAL_2, 0xFFFFFF, 0xFF0000);
        }
        // 

    }
}